import React, { useState, useCallback, memo } from 'react';
import { translate } from '@utils/i18n';
import { Button, Text } from '@ui';
import StatusIndicator from './StatusIndicator';
import TimeDisplay from './TimeDisplay';
import SubprocessItem from './SubprocessItem';
function SubmissionItem({ submission }) {
    const { id, startedAt, status, activities } = submission;
    const [isExpanded, setIsExpanded] = useState(status === 'in_progress' || status === 'pending');
    const toggleExpanded = useCallback(() => {
        setIsExpanded((prevState) => !prevState);
    }, []);
    const handleKeyDown = useCallback((event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            toggleExpanded();
        }
    }, [toggleExpanded]);
    return (React.createElement("div", { className: "submission-item" },
        React.createElement("div", { className: `submission-header ${isExpanded ? 'expanded' : ''}`, onClick: toggleExpanded, onKeyDown: handleKeyDown, role: "button", tabIndex: 0, "aria-expanded": isExpanded, "aria-controls": `submission-details-${id}` },
            React.createElement("div", { className: "submission-info" },
                React.createElement("div", { className: "submission-title" },
                    React.createElement(Text, { variant: "small", as: "h3" }, translate('submission.title', { namespace: 'features.iim_review.submissions_timeline', id })),
                    React.createElement(StatusIndicator, { status: status }),
                    React.createElement(Button, { variant: "highlighted", onClick: (e) => {
                            e.stopPropagation();
                            toggleExpanded();
                        } }, isExpanded
                        ? translate('submission.collapse_details', { namespace: 'features.iim_review.submissions_timeline' })
                        : translate('submission.expand_details', { namespace: 'features.iim_review.submissions_timeline' })))),
            React.createElement("div", { className: "submission-time" },
                React.createElement(TimeDisplay, { timestamp: startedAt }))),
        React.createElement("div", { id: `submission-details-${id}`, className: `submission-details ${isExpanded ? '' : 'collapsed'}`, "aria-hidden": !isExpanded }, activities && activities.subprocesses && activities.subprocesses.filter((s) => s.processType).length > 0 ? (React.createElement("div", { className: "subprocesses-list" }, activities.subprocesses
            .filter((s) => s.processType)
            .map((subprocess, i) => (React.createElement(SubprocessItem, { key: `${id}-subprocess-${i}`, subprocess: subprocess }))))) : (React.createElement("div", { className: "no-subprocesses" },
            React.createElement(Text, { variant: "body", as: "p" }, translate('submission.no_subprocesses', { namespace: 'features.iim_review.submissions_timeline' })))))));
}
export default memo(SubmissionItem);
